import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'app/services/general.service';
import {DatePipe} from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ProvidersService } from 'app/services/providers.service';
const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

@Component({
  selector: 'app-modal-bulk-load',
  templateUrl: './modal-bulk-load.component.html',
  styleUrls: ['./modal-bulk-load.component.scss']
})
export class ModalBulkLoadComponent implements OnInit {
  data: any = {};

  hasBaseDropZoneOver = false;
  loadBtn = false;

  showDrop=true;
  showDropZ=true;

  dataForeign: any = {};
    private base64textString: String = '';
    base64Pdf: string;
    filesUpload = 0;

    filesArr = [];
    filesArrZ =[];
    cpCompany: any;
    diatanceCdfi: any;
    alertDistance = false;
    filesCountUpload = 0;
    filesCountUploadZ=0;

    step = 1;
    msgResp: any;
    txtHead = 'BUTTONS.ADDINVOICE';
    totalSelect: any;
    info: any = {};

    uploader: FileUploader = new FileUploader({
      url: URL,
      isHTML5: true
    });


  constructor(private toastr: ToastrService, private gralService: GeneralService, public dialogRef: MatDialogRef<ModalBulkLoadComponent>, private provService: ProvidersService) { }


  ngOnInit() {
  }

  upp(evt){
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    this.fileUpload(file);
  }

  uppZip(evt){
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    this.fileUploadZip(file);
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  dropped(e){
    for(let g = 0; g < e.length; g++){
      this.fileUpload(e[g]);
    }
  }

  droppedZ(e){
    for(let g = 0; g < e.length; g++){
      this.fileUploadZip(e[g]);
    }
  }

  fileUpload(file){
    const patternXls = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const patternXls2 = /xlsx/;

    if (!file.type.match(patternXls) ) {

      this.toastr.error('El archivo ' + file.name + ' tiene formato de archivo inválido, solo se acepta xls', 'Error al cargar archivo');
        return false;
    }

    this.filesArr.push({file: file, name: file.name, size: file.size, color: 'green', type: 'xls', date: null, error: null, id: null, url: 'http://concent.com.mx'});
    this.showDrop = false;
  }

  fileUploadZip(file){

    const patternZip = /zip/;

    if (!file.type.match(patternZip)) {
      this.toastr.error('El archivo ' + file.name + ' tiene formato de archivo inválido, solo se acepta zip', 'Error al cargar archivo');
        return false;
    }

    this.filesArrZ.push({file: file, name: file.name, size: file.size, color: 'green', type: 'pdf', date: null, error: null, id: null, url: 'http://concent.com.mx'});
    this.showDropZ = false;
  }

  _loadExcel(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64Pdf = btoa(binaryString);
    this.info.excelBase64 = btoa(binaryString);
  }
  _loadZip(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64Pdf = btoa(binaryString);
    this.info.zipBase64 = btoa(binaryString);
  }

  deleteFile(idx){
    this.filesArr.splice(idx, 1);
    this.filesCountUpload--;
    this.showDrop = true;
  }


  deleteFileZ(idx){
    this.filesArrZ.splice(idx, 1);
    this.filesCountUploadZ--;
    this.showDrop = true;
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  sendBulk(){
    const datePipe = new DatePipe('en-US');
    this.loadBtn = true;

    if(this.filesArr.length == 0){
      this.toastr.error('Favor de agregar archivo excel', 'Error al cargar archivo');
      this.loadBtn = false;
      return false;
    }

    if(this.filesArrZ.length == 0){
      this.toastr.error('Favor de agregar archivo zip', 'Error al cargar archivo');
      this.loadBtn = false;
      return false;
    }

    //excel
    const reader = new FileReader();
    reader.onload = this._loadExcel.bind(this);
    reader.readAsBinaryString(this.filesArr[0].file);

    //zip
    const readerZ = new FileReader();
    readerZ.onload = this._loadZip.bind(this);
    readerZ.readAsBinaryString(this.filesArrZ[0].file);

    this.info.usuario   = 'click';
    this.info.password  = "iq9z;Sd?f7q7";

    setTimeout(()=>{

      this.loadBtn = true;

      this.provService.postBulkLoad(this.info, '123').then((res:any)=>{
        if(res.resultado == true)
          this.toastr.success(res.mensaje,'');
        else
        this.toastr.error(res.mensaje,'');
      this.dialogRef.close();
      });
    },9000)

  }
  // ********************    ********************************** //
}
